import SidePage from '@/shared/SidePage'
import { IMaintenanceEvent } from '../../calendar.types'
import CalendarSidePageViewContent from './components/CalendarSidePageViewContent'
import { useRecoilValue } from 'recoil'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import useMaintenanceProcess from '@/pages/Processes/Maintenance/hooks/useMaintenanceProcess'
import useMaintenanceBlankSchema from '@/pages/Processes/Maintenance/hooks/useMaintenanceBlankSchema'
import equipmentSelectors from '@/pages/Equipment/equipment.selectors'
import useResponsibleUsers from './hooks/useResponsibleUsers'

interface IProps {
  event: IMaintenanceEvent
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
}

const CalendarSidePage = (props: IProps) => {
  const equipmentMap = useRecoilValue(equipmentSelectors.getEquipmentMap)
  const maintenanceProcess = useMaintenanceProcess(props.event.metadata.processId)
  const maintenanceProcessRule = maintenanceProcess.rules.find((item) => item.id === props.event.metadata.processRuleId)
  const maintenanceBlankSchema = useMaintenanceBlankSchema(maintenanceProcessRule.blankSchemaId)
  const { responsibleUsers, loading } = useResponsibleUsers(props.event.metadata.responsibleUsers)

  const renderContent = () => {
    if (!props.event || loading) {
      return (
        <div className="flex-lines center" style={{ marginTop: '100px' }}>
          <ThreeDotsLoader inscription="Загружаем данные..." />
        </div>
      )
    }

    return (
      <CalendarSidePageViewContent
        maintenanceBlankSchema={maintenanceBlankSchema}
        responsibleUsers={responsibleUsers}
        equipment={equipmentMap[props.event.metadata.equipmentId]}
        event={props.event}
        onClose={props.onClose}
      />
    )
  }

  return (
    <SidePage
      style={{ paddingRight: '0' }}
      onClose={props.onClose}
      open={props.open}
      size="large"
      onCloseAnimationEnd={props.onCloseAnimationEnd}
    >
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.event) return null

  return <CalendarSidePage {...props} />
}
